import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';
import { HierarchyTemplateAttribute } from './hierarchy-template-attribute';
import { HierarchyTemplateTab } from './hierarchy-template-tab';

export class HierarchyTemplateGroup implements ViewModel {

  public friendlyTypeNameSingular: string = 'Hierarchy Template Group';
  public apiRoute: string = CONFIG.apiRoutes.hierarchyTemplatesGroups;

  public hierarchyTemplateGroupId: string;
  public name: string;
  public hierarchyTemplateTabId: string;
  public hierarchyTemplateTab: HierarchyTemplateTab;
  public attributes: HierarchyTemplateAttribute[] = [];

  public json(): HierarchyTemplateGroup {
    return this;
  }

  public loadFromJson(data: HierarchyTemplateGroup): void {
    this.hierarchyTemplateGroupId = data.hierarchyTemplateGroupId;
    this.hierarchyTemplateTabId = data.hierarchyTemplateTabId;

    if (data.hierarchyTemplateTab) {
      this.hierarchyTemplateTab = data.hierarchyTemplateTab;
    }

    this.name = data.name;
    this.attributes = data.attributes;
  }

}
